import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import DeliveryWarehousesETLImage from './DeliveryWarehousesETLImage'

const data = {
  anchorId: `warehouses-etl`,
  overline: `Delivery`,
  heading: `Warehouses / ETL`,
  description: `Most companies load data into a data warehouse. It’s the source of truth for various analytics deep dives. Getting data in there can be challenging, as you need to consider schema inference, data cleaning, loading at off peak hours, and incrementally syncing new data. Here’s how we do it.`,
  link1: `https://news.ycombinator.com/item?id=14508413`,
  link1Text: `Sorted by custom ID format (66 comments)`,
  link2: `https://news.ycombinator.com/item?id=13886885`,
  link2Text: `Proactively identifies and limits hot shards (252 comments)`,
  accordionSection: SectionWithAccordion.WAREHOUSES_ETL,
}

const DeliveryWarehousesETL: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, link1, link1Text, link2, link2Text, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link1}>{link1Text}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link2}>{link2Text}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <DeliveryWarehousesETLImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default DeliveryWarehousesETL
